import {AutogenLayoutMobileCommMessageQuickInfo} from "./autogen/AutogenLayoutMobileCommMessageQuickInfo";
import {ClickEvent} from "@mcleod/components";
import {ModelRow, Navigation} from "@mcleod/core";

export class MobileCommMessageQuickInfo extends AutogenLayoutMobileCommMessageQuickInfo {

    onLoad(): void | Promise<void> {
        this.mainDataSource = this.layoutMobileCommMessageText.mainDataSource;
    }

    private buttonViewMessageOnClick(event: ClickEvent) {
        if (this.mainDataSource.data == null) return;
        const data: ModelRow = this.mainDataSource.activeRow;
        const id = data.get("id");
        const mcUnitNo = data.get("mc_unit_no");
        Navigation.navigateTo(
            `lme/dispatch/mobilecomm/MobileCommList?tab=1\u0026id=${id}\u0026key=${mcUnitNo}`,
            {newTab: true}
        );
    }

}
